import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AuthGuard } from './auth/AuthGuard';
import { ProfileGate } from './auth/ProfileGate';
import { UserProvider } from './hooks/UserProvider';
import { Sidebar } from './components/layout/Sidebar';
import { AboutPage } from './pages/AboutPage';
import { HomePage } from './pages/HomePage';
import { LookupPage } from './pages/LookupPage';
import { CustomersListPage } from './pages/CustomersListPage';
import { CustomerDetailPage } from './pages/CustomerDetailPage';
import { PromotionsPage } from './pages/PromotionsPage';
import { AdminPage } from './pages/AdminPage';
import { AddCustomerModal } from './components/customers/AddCustomerModal';
import { ComposerProvider } from './components/comms/ComposerProvider';
import './styles/app.css';

function Shell() {
  const location = useLocation();
  const navigate = useNavigate();

  // Both the About easter egg and the Add-customer form are overlays driven by
  // the URL, so they layer over whatever screen is beneath.
  const aboutOpen = location.pathname === '/about';
  const addOpen = location.pathname === '/customers/new';

  const closeOverlay = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  return (
    <div className="app-shell">
      <Sidebar onLogoClick={() => navigate('/about')} />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<HomePage onAddCustomer={() => navigate('/customers/new')} />} />
          <Route path="/lookup" element={<LookupPage />} />
          <Route path="/customers" element={<CustomersListPage />} />
          <Route path="/customers/:id" element={<CustomerDetailPage />} />
          <Route path="/promotions" element={<PromotionsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          {/* /customers/new and /about render the screen beneath (Home) + an overlay */}
          <Route path="/customers/new" element={<HomePage onAddCustomer={() => navigate('/customers/new')} />} />
          <Route path="/about" element={<HomePage onAddCustomer={() => navigate('/customers/new')} />} />
          <Route path="*" element={<div className="state-msg">Page not found.</div>} />
        </Routes>
      </main>

      {addOpen && (
        <AddCustomerModal
          onClose={closeOverlay}
          onCreated={(cid) => navigate(`/customers/${cid}`)}
          onOpenExisting={(cid) => navigate(`/customers/${cid}`)}
        />
      )}
      {aboutOpen && <AboutPage onClose={closeOverlay} />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthGuard>
        <UserProvider>
          <ProfileGate>
            <ComposerProvider>
              <Shell />
            </ComposerProvider>
          </ProfileGate>
        </UserProvider>
      </AuthGuard>
    </BrowserRouter>
  );
}
